// Override Settings
var searchlyFilterConfig = {
	general: {
		limit: searchlyThemeConfig.custom.products_per_page,
		/* Optional */
		loadProductFirst: false,
	}
};


/************************** BUILD PRODUCT LIST **************************/


(function() {
	SEARCHLY.inject(this);

	// Custom product placeholder
	ProductListPlaceholder.prototype.getTemplate = function() {
		return	'<div class="{{wrapperClass}} {{class.filterProductSkeleton}}">' +
					'<div class="card critical-clear card--reveal">' +
						'<div class="card__wrapper  text-center">' +
							'<div class="{{class.filterProductSkeleton}}-image" style="padding-top: {{paddingTop}}%"></div>' +
							'<div class="{{class.filterProductSkeleton}}-meta">' +
								'<span class="{{class.filterSkeletonText}} {{class.filterSkeleton}}"></span>' +
								'<span class="{{class.filterSkeletonText}} {{class.filterSkeleton}}-width1"></span>' +
							'</div>' +
						'</div>' +
					'</div>' +
				'</div>';
	}

	// Build Product Grid Item
	ProductGridItem.prototype.compileTemplate = function(data) {
		if (!data) data = this.data;
		/*** Prepare data ***/
		var images = data.images_info;
		// Displaying price base on the policy of Shopify, have to multiple by 100
		var soldOut = !data.available; // Check a product is out of stock
		var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		var priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Get First Variant (selected_or_first_available_variant)
		var firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function(e) { return e.id == Utils.getParam('variant'); });
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		/*** End Prepare data ***/

		// Get Template
		var itemHtml = searchlyTemplate.productGridItemHtml;

		// Add Custom class
		var cardWrapperPaddingClass = searchlyThemeConfig.custom.show_spacing ? searchlyTemplate.cardWrapperPaddingClass : '';
		itemHtml = itemHtml.replace(/{{itemCardWrapperPaddingClass}}/g, cardWrapperPaddingClass);

		// Add Grid Class
		var gridClass = searchlyThemeConfig.custom.grid_style == 'grid' ? 'card__info--aligned' : '';
		itemHtml = itemHtml.replace(/{{itemGridClass}}/g, gridClass);

		// Add Thumbnail
		var itemImagesHtml = '';
		if (searchlyThemeConfig.custom.grid_style == 'grid') {
			if (images.length > 0) {
				var aspect_ratio = images[0]['width'] / images[0]['height'];
				itemImagesHtml += '<div class="card__image-wrapper card__image-wrapper--aligned">';
				itemImagesHtml += '<div class="card__preloader"></div>';
				itemImagesHtml += '<img class="card__image card__image--align lazyload fade-in" data-src="' + Utils.getFeaturedImage(images, '{width}x') + '" ' +
										'src="' + Utils.getFeaturedImage(images, '300x') + '"' +
										'data-parent-fit="cover"' +
										'data-widths="[360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" ' +
										'data-aspectratio="' + aspect_ratio + '" ' +
										'data-sizes="auto" ' +
										'alt="{{itemTitle}}"' +
										'data-variant-image>';
				itemImagesHtml +=   '<noscript>' +
										'<img src="' + Utils.getFeaturedImage(images, '1024x1024') + '" alt="{{itemTitle}}" class="card__image">' +
									'</noscript>';
				itemImagesHtml += '</div>';
			}
		} else {
			if (images.length > 0) {
				var aspect_ratio = images[0]['width'] / images[0]['height'];
				itemImagesHtml += '<div class="card__image-wrapper" style="padding-top:' + 1 / aspect_ratio * 100 + '%">';
				itemImagesHtml += '<div class="card__preloader"></div>';
				itemImagesHtml += '<img class="card__image lazyload fade-in" data-src="' + Utils.getFeaturedImage(images, '{width}x') + '" ' +
										'data-widths="[180, 220, 300, 360, 460, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" ' +
										'data-aspectratio="' + aspect_ratio + '" ' +
										'data-sizes="auto" ' +
										'alt="{{itemTitle}}">';
				itemImagesHtml +=   '<noscript>' +
										'<img src="' + Utils.getFeaturedImage(images, '1024x1024') + '" alt="{{itemTitle}}" class="card__image">' +
									'</noscript>';
				itemImagesHtml += '</div>';
			}
		}

		itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);

		// Add Price
		var itemPriceHtml = '';
		if (!soldOut) {
			itemPriceHtml += '<div class="card__price">';
			if (onSale) {
				if (priceVaries) {
					itemPriceHtml += '<span class="visually-hidden">' + searchlyThemeConfig.label.price + '</span>';
					itemPriceHtml += searchlyThemeConfig.label.sale_from_price.replace(/{{ price }}/g, Utils.formatMoney(data.price_min, Globals.moneyFormat, true));
				} else {
					itemPriceHtml += '<span class="visually-hidden">' + searchlyThemeConfig.label.sale_price + '</span>';
					itemPriceHtml += '<span class="card__price--sale">' + Utils.formatMoney(data.price_min, Globals.moneyFormat, true) + '</span>';

					itemPriceHtml += '<span class="visually-hidden">' + searchlyThemeConfig.label.regular_price + '</span>';
					itemPriceHtml += '<span class="card__price--regular-strike">' +
										'<span class="card__price--regular">' + Utils.formatMoney(data.compare_at_price_min, Globals.moneyFormat, true) + '</span>' +
									'</span>';
				}
				// Sale label
				itemPriceHtml += ' <span class="card__badge';
				if (searchlyThemeConfig.label.sale.length > 6) itemPriceHtml += ' card__badge--large';
				itemPriceHtml += '">';
				itemPriceHtml += searchlyThemeConfig.label.sale;
				itemPriceHtml += '</span>';
			} else {
				if (priceVaries) {
					itemPriceHtml += searchlyThemeConfig.label.from_price.replace(/{{ price }}/g, Utils.formatMoney(data.price_min, Globals.moneyFormat, true));
				} else {
					itemPriceHtml += Utils.formatMoney(data.price_min, Globals.moneyFormat, true);
				}
			}
			itemPriceHtml += '</div>';
		} else {
			itemPriceHtml += '<div class="card__availability">' + searchlyThemeConfig.label.sold_out + '</div>';
		}
		itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

		// Add Sale Label
		var onSaleLabel = '',
			onSaleClass = searchlyThemeConfig.label.sale.length > 6 ? 'card__badge--large' : '';
		if (onSale) {
			onSaleLabel += '<span class="card__badge ' + onSaleClass + '">';
			onSaleLabel += searchlyThemeConfig.label.sale;
			onSaleLabel += '</span>';
		}
		itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, onSaleLabel);

		// Add Vendor
		var itemVendorHtml = searchlyThemeConfig.custom.show_vendor ? searchlyTemplate.vendorHtml.replace(/{{itemVendorLabel}}/g, data.vendor) : '';
		itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

		// Add main attribute (Always put at the end of this function)
		itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
		itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));

		return itemHtml;
	};

	// Customize the display of product grid
	ProductList.prototype.buildProductList = function(data, eventType) {
		if (!data) data = this.data;
		var self = this;

		var totalProduct = data.length;
		// Get columns of product list
		var columnNumber = searchlyThemeConfig.custom.desktop_columns;
		if (Utils.isMobile()) {
			columnNumber = searchlyThemeConfig.custom.mobile_columns;
		}
		var customData = [];
		for (var i = 0; i < totalProduct; i++) {
			var j = i + 1;
			var index = j;
			if (j > columnNumber) {
				if (j % columnNumber == 0) index = columnNumber;
				else index = j % columnNumber;
			}
			if (typeof customData[index - 1] == 'undefined') customData[index - 1] = [];
			customData[index - 1].push(this.productItems[i].$element);
		}

		var columns = jQ('<div></div>');
		for (var i = 0; i < customData.length; i++) {
			// Add column wrapper
			var columnHtml = '';
			columnHtml += '<div class="card-list__column grid grid__item ';
			if (columnNumber == 4) {
				columnHtml += ' medium-up--one-quarter';
			} else if (columnNumber == 3) {
				columnHtml += ' medium-up--one-third';
			} else {
				columnHtml += ' medium-up--one-half';
			}
			if (Utils.isMobile() && columnNumber == 2) columnHtml += ' small--one-half';
			columnHtml += '"></div>';

			var column = jQ(columnHtml);
			for (var j = 0; j < customData[i].length; j++) {
				column.append(customData[i][j]);
			}
			columns.append(column);
		}

		// Remove the sort by attribute of product list element
		this.$element.removeAttr('data-searchly-sort');
		// Clear the HTML content of product list if the pagination is default OR the event type is not page
		if (Utils.isDefaultPaginationType() || (!Utils.isDefaultPaginationType() && this.eventType != 'page')) {
			this.$element.html('');
			jQ(window).unbind('scroll');
		}
		// Prepend the product result if the event is load previous
		if (this.$element.find('.card-list__column').length) {
			columns.find('.card-list__column').each(function(i, column) {
				if (Utils.isLoadPreviousPagePaginationType() && parseInt(window.sessionStorage.getItem(this.settings.sessionStoragePreviousPageEvent))) {
					self.$element.find('.card-list__column').eq(i).prepend(jQ(column).children());
				} else {
					self.$element.find('.card-list__column').eq(i).append(jQ(column).children());
				}
			});
		} else {
			if (Utils.isLoadPreviousPagePaginationType() && parseInt(window.sessionStorage.getItem(this.settings.sessionStoragePreviousPageEvent))) {
				this.$element.prepend(columns);
			} else {
				this.$element.append(columns);
			}
		}
	}

	/************************** END BUILD PRODUCT LIST **************************/

	// Build Pagination

	ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {
		if (!totalProduct) totalProduct = this.totalProduct;
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

		if (Settings.getSettingValue('general.paginationType') == 'default' && totalPage > 1) {
			var paginationHtml = searchlyTemplate.paginateHtml;

			// Build Previous
			var previousHtml = (currentPage > 1) ? searchlyTemplate.previousActiveHtml : searchlyTemplate.previousDisabledHtml;
			previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
			paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

			// Build Next
			var nextHtml = (currentPage < totalPage) ? searchlyTemplate.nextActiveHtml :  searchlyTemplate.nextDisabledHtml;
			nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
			paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

			// Create page items array
			var beforeCurrentPageArr = [];
			for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
				beforeCurrentPageArr.unshift(iBefore);
			}
			if (currentPage - 4 > 0) {
				beforeCurrentPageArr.unshift('...');
			}
			if (currentPage - 4 >= 0) {
				beforeCurrentPageArr.unshift(1);
			}
			beforeCurrentPageArr.push(currentPage);

			var afterCurrentPageArr = [];
			for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
				afterCurrentPageArr.push(iAfter);
			}
			if (currentPage + 3 < totalPage) {
				afterCurrentPageArr.push('...');
			}
			if (currentPage + 3 <= totalPage) {
				afterCurrentPageArr.push(totalPage);
			}

			// Build page items
			var pageItemsHtml = '';
			var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
			for (var iPage = 0; iPage < pageArr.length; iPage++) {
				if (pageArr[iPage] == '...') {
					pageItemsHtml += searchlyTemplate.pageItemRemainHtml;
				} else {
					pageItemsHtml += (pageArr[iPage] == currentPage) ? searchlyTemplate.pageItemSelectedHtml : searchlyTemplate.pageItemHtml;
				}
				pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
				pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
			}
			paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

			return paginationHtml;
		}

		return '';
	};

	// Build Pagination - Load more
	ProductPaginationLoadMore.prototype.compileTotalTemplate = function() {
		/**
		 * If enable the Load previous feature and the evnet type is page:
		 * => Get the next loading page is from session storage OR get the next loading page from query param
		 */
		if (Utils.isLoadPreviousPagePaginationType() && this.parent.eventType == 'page') {
			this.nextPage = parseInt(window.sessionStorage.getItem(this.settings.sessionStorageCurrentNextPage));
		} else {
			this.nextPage = Globals.queryParams.page;
		}
		// Set from index
		var from = (this.nextPage - 1) * Globals.queryParams.limit + 1;
		var current_total = jQ(Selector.products + ' .card-list__column > div.card').length;
		if (current_total) {
			from -= current_total - Globals.queryParams.limit;
		}
		// Set to index
		var product_index = (this.nextPage - 1) * Globals.queryParams.limit + 1;
		var to = product_index + this.data.products.length - 1;

		return this.getTemplate('total')
			.replace(/{{progressLable}}/g, Labels.loadMoreTotal)
			.replace(/{{ from }}/g, from)
			.replace(/{{ to }}/g, to)
			.replace(/{{ total }}/g, this.totalProduct)
			.replace(/{{class.productLoadMore}}/g, Class.productLoadMore)
	}

	/************************** BUILD TOOLBAR **************************/

	// Build Sorting
	ProductSorting.prototype.compileTemplate = function() {
		var html = '';
		if (searchlyTemplate.hasOwnProperty('sortingHtml')) {
			var sortingArr = Utils.getSortingList();
			if (sortingArr) {
				// Build content
				var sortingItemsHtml = '';
				for (var k in sortingArr) {
					sortingItemsHtml += '<option value="' + k +'">' + sortingArr[k] + '</option>';
				}
				html = searchlyTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
			}
		}
		return html;
	};

	/************************** END BUILD TOOLBAR **************************/

	// Add additional feature for product list, used commonly in customizing product list
	ProductList.prototype.afterRender = function(data) {
		if (!data) data = this.data;
	};

	// Build additional elements
	FilterResult.prototype.afterRender = function(data) {
		if (!data) data = this.data;
	};
})();
